<template>
  <div>
    <WrapperPreviewCategory customClass="section-preview_lk">
      <GridTable
        :data-rows="showingServerData"
        :rewrite-headers="rwrw"
        :headers="headers"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="countCells"
        :max-table-height="maxTableHeight"
        ref="npg-table"
        key="form-V"
      >
        <template v-for="item in headersForRows" v-slot:[calcHeaderName(item.dataField)]>
          <div :key="item.dataField" :class="item.headerClass" style="min-width: 100%">
            <div class="d-flex flex-row align-center" style=" writing-mode: vertical-rl; text-orientation: mixed;">
              {{ item.text }}
            </div>
          </div>
        </template>
        <template #header-qwer="{item}">
          {{ item.text }}
        </template>
        <template #sprKcpGroup="{row}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <div style="">
              {{ calcCodeUgs(row) }}
            </div>
            <div class="ml-3">
              {{ calcNameUgs(row) }}
            </div>
          </template>
        </template>
        <template v-for="item in headersForRowsWithEditableCells" v-slot:[item.dataField]="{row}">
          {{ calcTemplate(row[item.dataField]) }}
        </template>
      </GridTable>
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
          class="pagination-table"
          v-model="userPages"
          :items="pagesPaginate"
          solo
          dense
          filled
          height="25"
          rounded
          style="max-width: 150px"
        ></v-autocomplete>
        <v-pagination
          v-model="page"
          :length="pagesVuetify"
          :total-visible="7"
        >
        </v-pagination>
      </div>
    </WrapperPreviewCategory>
  </div>
</template>

<script>
import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {setAppealDialog} from "@/mixins/forms5/appealDialog";
import {mapGetters} from "vuex";

export default {
  name: "formV",
  mixins: [setAppealFromOneToFourDialog, headerTooltipFunctions, setAppealDialog],
  components: {GridTable, WrapperPreviewCategory,},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  
  data() {
    return {
      serverData: [],
      loadingData: false,
      changingHeaders: false,
      headers: [],
      dataFields: [],
      headersRows: [],
      headersRowsDefault: [
        {
          dataField: 'sprKcpGroup',
          cols: 1,
          rows: 1,
          headerClass: 'text-center',
          class: 'd-flex flex-row justify-start',
          text: `1`,
          order: 2,
          variable: true,
        },
      ],
      headersDefault: [
        {
          dataField: 'qwer',
          cols: 1,
          rows: 2,
          text: 'Код и наименование УГСН (НПС)',
          class: 'd-flex flex-row align-start justify-start ',
          headerClass: 'align-end ',
          headerStyles: `min-width: 350px;`,
          order: 0,
          variable: false,
        },
        {
          dataField: 'npg11',
          cols: 1,
          rows: 1,
          headerClass: 'text-center',
          text: `трудоустройство 2020 г. (выпуск 2019 г.)`,
          order: 1,
          variable: false,
        },
        {
          dataField: 'npg12',
          cols: 1,
          rows: 1,
          headerClass: 'text-center',
          text: `трудоустройство 2021 г. (выпуск 2020 г.)`,
          order: 1,
          variable: false,
        },
        {
          dataField: 'npg13',
          cols: 1,
          rows: 1,
          headerClass: 'text-center',
          text: `трудоустройство 2022 г. (выпуск 2021 г.)`,
          order: 2,
          variable: false,
        },
      ],
      countCells: 1,
      loadingMenu: {value: false, id: ''},
      full: false,
      rwrw: true,
      page: 1,
      userPages: 25,
      pagesPaginate: [
        {value: 25, text: 25},
        {value: 10000, text: 'все'},
      ]
      
    }
  },
  
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
    maxTableHeight() {
      return window.innerHeight - 225 + 'px'
    },
    showingServerData() {
      return this.serverData.slice((this.page - 1) * this.userPages, (this.page) * this.userPages)
    },
    pagesVuetify() {
      return Math.ceil(this.serverData.length / parseInt(this.userPages, 10));
    },
    headersForRowsWithEditableCells() {
      return this.headersForRows.filter(el => el.dataField !== 'sprKcpGroup')
    },
    headersForRows() {
      return this.headersRows.filter(el => el.variable).map(el => {
        return {
          ...el,
          styles: (row) => {
            if (el.dataField !== 'sprKcpGroup')
              return row.uslName ? 'display: none;' : 'justify-content: unset; text-align: center; '
            else
              return ''
          },
          colsDataCalc: (row, cell) => {
            if (el.dataField !== 'sprKcpGroup')
              return cell.cols;
            else
              return row.uslName ? this.countCells : 1;
          },
        }
      })
    }
  },
  
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  
  created() {
    this.appealInfo.nameForm = 'FORM_V'
    this.loadingDataTable();
  },
  methods: {
    loadFullInfo() {
      this.full = !this.full;
      this.loadingDataTable()
    },
    calcTemplate(v) {
      if (!v) return v;
      if (v == null || v === 'н.д.')
        return 'н.д.';
      const dot = v.indexOf(',');
      if (dot !== -1) {
        const newV = v.slice(0, dot) + '.' + v.slice(dot + 1, dot + 2)
        return Intl.NumberFormat('ru-RU').format(Number.parseFloat(newV));
      } else
        return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v));
    },
    calcCodeUgs(row) {
      return row.kcpGroup?.code
    },
    calcNameUgs(row) {
      return row.kcpGroup?.name
    },
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm2('formV', true, this.chosenChildOrg?.id);
        const res = this.serverData.find(el => !el.uslName);
        const headers = {
          'трудоустройство 2020 г. (выпуск 2019 г.)': [],
          'трудоустройство 2021 г. (выпуск 2020 г.)': [],
          'трудоустройство 2022 г. (выпуск 2021 г.)': [],
        };
        for (const value of Object.keys(res)) {
          const indexSearchMtr = value.indexOf('Mtr');
          if (indexSearchMtr !== -1) {
            const year = `трудоустройство 20${value.substr(-5, 2)} г. (выпуск 20${value.substr(-5, 2) - 1} г.)`;
            headers[year].push(value);
          }
        }
        this.headers = [...this.headersDefault];
        this.headersRows = [...this.headersRowsDefault];
        this.countCells = 1;
        for (const [key, value] of Object.entries(headers)) {
          const item = this.headers.find(el => el.text === key);
          item.cols = value.length;
          if (value.length === 0) {
            const removedItemIndex = this.headers.findIndex(el => el.text === key);
            this.headers.splice(removedItemIndex, 1)
            continue;
          }
          this.countCells += value.length;
          const newArr = value.map(el => {
            const info = this.findInfoForCell(el);
            return {
              dataField: el,
              cols: 1,
              rows: 1,
              text: info.form,
              order: 7,
              headerClass: 'pa-0 font-size-small__important',
              variable: true,
            }
          });
          this.headersRows.push(...newArr);
          this.headers.push(...newArr);
        }
        this.rwrw = false;
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
        this.rwrw = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: auto;
  color: #89A0B0;
  background-color: #FFFFFF;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 6px 18px rgb(0 0 0 / 6%);
  margin-bottom: 20px;
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
}

.table__item {
  padding: 10px;
  border: 1px solid #CFD8DC;
}

.table__header {
  border-top: 1px solid #CFD8DC;
}

.top-line {
  border-top: none;
}

.left-line {
  border-left: none;
}

.bottom-line {
  border-bottom: none;
}

.right-line {
  border-right: none;
}

.item-data:hover {
  background: rgba(207, 224, 236, 0.42);
}
</style>